import React from 'react'
import PropTypes from 'prop-types'
import CustomBanner from './CustomBanner'
import BannerPlaceholder from './BannerPlaceholder'

import './style.css.scss'

const Banner = ({
  showHeader, showContent, config, themeColorHex, textColor, isItemView, isMobile, children
}) => {
  return config.show
    ? <CustomBanner
        config={config}
        themeColorHex={themeColorHex}
        showContent={showContent}
        textColor={textColor}
        isItemView={isItemView}
        isMobile={isMobile}>
        {children}
      </CustomBanner>
    : showHeader && <BannerPlaceholder />
}

Banner.propTypes = {
  config: PropTypes.object,
  themeColorHex: PropTypes.string,
  textColor: PropTypes.string,
  showHeader: PropTypes.bool,
  isItemView: PropTypes.bool,
  isMobile: PropTypes.bool,
  showContent: PropTypes.bool.isRequired
}

Banner.defaultProps = {
  showContent: true,
  isMobile: false
}

export default Banner

